import React, { Component } from "react";
import {
  ErrorNotification,
  MnemoLoading,
  ModalHandler,
  SuccessNotification,
  Title,
} from "components/misc";

import { withRouter } from "react-router-dom";
import { MTable } from "components/table";
import { BoxDanger } from "components/misc";
import { ROUTES } from "const";
import { MInput, MSelect } from "components/forms";
import { adminService, networkErrorHelper } from "libs";

import { Container, Row, Col } from "design-react-kit";

class LessonOnSiteClassBadge extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      hasSearched: false,
      payload: [],
      payloadToRender: [],
      pagination: {
        currentPage: 1,
        pageSize: 70,
        totalPages: 1,
        totalItems: 0,
      },
      searchFilter: {
        searchAA: "",
        searchCompany: "",
        searchCategoryCode: "",
        searchRegistrationCode: "",
      },
      DataFromModal: {
        aa: "",
        company: "",
        categoryCode: "",
      },
      rndKey: 0,
      searchField: [
        {
          id: "searchAA",
          label: "anno accademico",
          type: "text",
          className: "form-control",
          value: "",
          onChange: (elm, value) => {
            this.handleSearchFieldChange("searchAA", value);
          },
        },
        {
          id: "searchCompany",
          field: "searchCompany",
          label: "Università",
          type: "text",
          className: "form-control",
          value: "",
          onChange: (elm, value) => {
            this.handleSearchFieldChange("searchCompany", value);
          },
        },
        {
          id: "searchCategoryCode",
          field: "searchCategoryCode",
          label: "Percorso",
          type: "text",
          className: "form-control",
          value: "",
          onChange: (elm, value) => {
            this.handleSearchFieldChange("searchCategoryCode", value);
          },
        },
        {
          id: "searchRegistrationCode",
          field: "searchRegistrationCode",
          label: "Codice di Registrazione",
          type: "text",
          className: "form-control",
          value: "",
          onChange: (elm, value) => {
            this.handleSearchFieldChange("searchRegistrationCode", value);
          },
        },
      ],
      PAYLOAD_CLASS_COMPANY: {
        options: [{ label: "Università", value: "" }],
      },
      PAYLOAD_CLASS_CATEGORYCODE: {
        options: [{ label: "Percorso", value: "" }],
      },
      PAYLOAD_COMPANY_MODAL: {
        options: [{ label: "Università", value: "" }],
      },
      PAYLOAD_CATEGORYCODE_MODAL: {
        options: [{ label: "Percorso", value: "" }],
      },
    };
  }

  getFieldValueById(id) {
    const field = this.state.searchField.find((item) => item.id === id);

    if (!field || field.value === null || field.value === undefined) {
      return "";
    }

    return typeof field.value === "string" ? field.value.trim() : field.value;
  }

  changePage = (newPage) => {
    this.setState(
      (prevState) => {
        if (
          newPage < 1 ||
          newPage > prevState.pagination.totalPages ||
          newPage === prevState.pagination.currentPage
        ) {
          return null;
        }

        return {
          pagination: {
            ...prevState.pagination,
            currentPage: newPage,
          },
        };
      },
      () => {
        this.loadQrCode();
      },
    );
  };

  //--- ---
  tableConfig = {
    columns: [
      {
        id: "id", // identifier of columns
        Header: "Column 0",
        isVisible: false, // IMPORTANT: hidden columns
        accessor: "id", // accessor is the "key" in the data
      },
      {
        id: "name",
        Header: "Nome",
        accessor: "name",
      },
      {
        id: "surname",
        Header: "Cognome",
        accessor: "surname",
      },
      {
        id: "registrationCode",
        Header: "Codice di Registrazione",
        accessor: "registrationCode",
      },
      {
        id: "courseCode",
        Header: "Codice Corso",
        accessor: "courseCode",
      },
      {
        id: "company",
        Header: "Università",
        accessor: "company",
      },
      {
        id: "aa",
        Header: "AA",
        accessor: "aa",
      },
      {
        id: "categoryCode",
        Header: "Percorso",
        accessor: "categoryCode",
      },
    ],
    actions: [
      {
        id: "detail",
        accessor: "registrationCode",
        label: "Dettagli",
        icon: "it-file",
        className: "MTable-actions",
        onClick: (e, value) => {
          window.open(ROUTES.MY_BADGE + "/" + value, "_blank");
          //window.location.href = ROUTES.LESSON_LIVE_SCHEDULE_FORM + "/" + value;
        },
      },
    ],
  };

  componentDidMount() {
    this.popolateSelect();
  }

  popolateSelect = () => {
    this.setState({ loading: true });

    adminService
      .popolateModalSelectQrCode()
      .then(({ data }) => {
        if (
          data.payload.dataList &&
          Array.isArray(data.payload.dataList.instituteCompanies) &&
          data.payload.dataList.instituteCompanies.length > 0 &&
          Array.isArray(data.payload.dataList.courseTypes) &&
          data.payload.dataList.courseTypes.length > 0
        ) {
          this.setState({
            PAYLOAD_CLASS_COMPANY: {
              options: [
                { label: "Università", value: "" },
                ...data.payload.dataList.instituteCompanies.map((company) => ({
                  label: company.instituteCompany,
                  value: company.instituteCompany,
                })),
              ],
            },
            PAYLOAD_CLASS_CATEGORYCODE: {
              options: [
                { label: "Percorso", value: "" },
                ...data.payload.dataList.courseTypes.map((category) => ({
                  label: category.courseType,
                  value: category.courseType,
                })),
              ],
            },
          });
        }

        this.setState({
          loading: false,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            payloadToRender: [],
            pagination: {
              ...this.state.pagination,
              totalPages: 1,
              totalItems: 0,
            },
            rndKey: Math.floor(Math.random() * 1000 + 1),
            hasSearched: true,
          });
        }
      });
  }; // populate select with api call using enhanced data structure

  popolateModalSelect = async () => {
    this.setState({ loading: true });

    return adminService
      .popolateModalSelectQrCode()
      .then(({ data }) => {
        if (
          data.payload.dataList &&
          Array.isArray(data.payload.dataList.instituteCompanies) &&
          data.payload.dataList.instituteCompanies.length > 0 &&
          Array.isArray(data.payload.dataList.courseTypes) &&
          data.payload.dataList.courseTypes.length > 0
        ) {
          this.setState({
            PAYLOAD_COMPANY_MODAL: {
              options: [
                { label: "Università", value: "" },
                ...data.payload.dataList.instituteCompanies.map((company) => ({
                  label: company.instituteCompany,
                  value: company.instituteCompany,
                })),
              ],
            },
            PAYLOAD_CATEGORYCODE_MODAL: {
              options: [
                { label: "Percorso", value: "" },
                ...data.payload.dataList.courseTypes.map((category) => ({
                  label: category.courseType,
                  value: category.courseType,
                })),
              ],
            },
          });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }
      });
  }; // popolate select in modal with api call

  handleSearchFieldChange = (fieldId, fieldValue) => {
    if (!fieldId) {
      return;
    }

    this.setState((prevState) => ({
      searchField: prevState.searchField.map((field) => {
        if (field.id !== fieldId) {
          return field;
        }

        return {
          ...field,
          value: typeof fieldValue === "string" ? fieldValue : "",
        };
      }),
    }));

    // Handle cascading when company changes
    if (fieldId === "searchCompany") {
      const subValueByCompany = this.state.PAYLOAD_CLASS_COMPANY.options.find(
        (option) => option.value === fieldValue,
      )?.subValue;

      this.setState({
        PAYLOAD_CLASS_CATEGORYCODE: {
          options: [
            { label: "Percorso", value: "" },
            ...(subValueByCompany || [])
              .sort((a, b) => a.label.localeCompare(b.label))
              .map((category) => ({
                label: category.label,
                value: category.value,
              })),
          ],
        },
      });

      // Reset category code value when company changes
      this.setState((prevState) => ({
        searchField: prevState.searchField.map((field) => {
          if (field.id !== "searchCategoryCode") {
            return field;
          }
          return {
            ...field,
            value: "",
          };
        }),
      }));
    }
  };

  handleSearchSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.onSearchForm();
  };

  onSearchForm = () => {
    const searchCompany = this.getFieldValueById("searchCompany");
    const searchCategoryCode = this.getFieldValueById("searchCategoryCode");
    const searchAA = this.getFieldValueById("searchAA");
    const searchRegistrationCode = this.getFieldValueById(
      "searchRegistrationCode",
    );

    this.setState(
      (prevState) => ({
        pagination: {
          ...prevState.pagination,
          currentPage: 1,
        },
        searchFilter: {
          ...prevState.searchFilter,
          searchCompany,
          searchCategoryCode,
          searchAA,
          searchRegistrationCode,
        },
      }),
      () => {
        this.loadQrCode();
      },
    );
  }; //onSearchForm

  loadQrCode = () => {
    this.setState({ loading: true });

    const { currentPage, pageSize } = this.state.pagination;

    const searchFilter = {
      searchCompany: this.state.searchFilter.searchCompany,
      searchCategoryCode: this.state.searchFilter.searchCategoryCode,
      searchAA: this.state.searchFilter.searchAA,
      searchRegistrationCode: this.state.searchFilter.searchRegistrationCode,
      page: currentPage,
      limit: pageSize,
    };

    adminService
      .getQrCodeList({ searchFilter })
      .then(({ data }) => {
        const qrcodelist = data?.payload?.qrcodelist || {};
        const items = Array.isArray(qrcodelist.items) ? qrcodelist.items : [];

        this.setState({
          loading: false,
          hasSearched: true,
          payload: items,
          payloadToRender: items,
          pagination: {
            ...this.state.pagination,
            currentPage,
            totalPages: parseInt(qrcodelist.totalPages),
            totalItems: parseInt(qrcodelist.totalItems),
          },
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false, hasSearched: true });
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            payloadToRender: [],
            pagination: {
              ...this.state.pagination,
              totalPages: 1,
              totalItems: 0,
            },
            rndKey: Math.floor(Math.random() * 1000 + 1),
            hasSearched: true,
          });
        }
      });
  }; // load qrcode

  /** */
  confirmGenerateQrCode = () => {
    // validate DataFromModal all fields must be filled
    const { aa, company, categoryCode } = this.state.DataFromModal;
    if (!aa || !company || !categoryCode) {
      ErrorNotification.render(
        "Tutti i campi sono obbligatori per generare i QRCode",
        "Comunicazione",
      );
      return true;
    }

    this.setState({ loading: true });

    adminService
      .generateQrCode(this.state.DataFromModal)
      .then(({ data }) => {
        if (data?.payload?.items?.rows.length > 0) {
          SuccessNotification.render(
            "QRCode generati con successo",
            "Comunicazione",
          );
        } else {
          ErrorNotification.render(
            "Non ci sono nuovi QRCode da generare con i parametri selezionati",
            "Comunicazione",
          );
        }

        this.setState(
          {
            loading: false,
          },
          () => {
            this.loadQrCode();
          },
        );
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false, hasSearched: true });
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            payloadToRender: [],
            pagination: {
              ...this.state.pagination,
              totalPages: 1,
              totalItems: 0,
            },
            rndKey: Math.floor(Math.random() * 1000 + 1),
            hasSearched: true,
          });
        }
      });
  };

  getDataFromModal = (_, value) => {
    if (_ === "aa") {
      this.setState({
        DataFromModal: {
          ...this.state.DataFromModal,
          aa: parseInt(value || 0),
        },
      });
    }

    if (_ === "company") {
      this.setState({
        DataFromModal: {
          ...this.state.DataFromModal,
          company: value,
        },
      });
    }

    if (_ === "categoryCode") {
      this.setState({
        DataFromModal: {
          ...this.state.DataFromModal,
          categoryCode: value,
        },
      });
    }
  }; //getDataFromModal

  /** */
  askGenerateQrCode = async () => {
    await this.popolateModalSelect();

    const form2Generate = [
      {
        name: "aa",
        field: "aa",
        label: "Anno Accademico:",
        type: "text",
        className: "mt-3 mb-1",
      },
      {
        name: "company",
        field: "company",
        label: "Università:",
        type: "text",
        className: "mt-3 mb-1",
      },
      {
        id: "categoryCodeModal",
        name: "categoryCode",
        field: "categoryCode",
        label: "Categoria:",
        type: "text",
        className: "mt-3 mb-1",
      },
    ];

    const code = (
      <>
        <p>Saranno aggiunti i badge non creati in precedenza, confermare?</p>
        <Row className="row col-md-12 mt-3">
          <Col className="col-md-6">
            <MInput {...form2Generate[0]} onChange={this.getDataFromModal} />
          </Col>
          <Col className="col-md-6 mt-3">
            <MSelect
              {...form2Generate[1]}
              payload={this.state.PAYLOAD_COMPANY_MODAL}
              onChange={this.getDataFromModal}
            />
          </Col>
          <Col className="col-md-12 mt-3">
            <MSelect
              {...form2Generate[2]}
              payload={this.state.PAYLOAD_CATEGORYCODE_MODAL}
              onChange={this.getDataFromModal}
            />
          </Col>
        </Row>
      </>
    );

    ModalHandler.show(
      null,
      "Importante.",
      code,
      null,
      this.confirmGenerateQrCode,
    );
  }; //askGenerateQrCode

  //--- ---

  render() {
    const { loading } = this.state;
    const { currentPage, totalPages, totalItems } = this.state.pagination;

    return (
      <>
        <div className="container mt-3 mb-4">
          <Title>Badges Accesso Aule in presenza</Title>
          <section className="m-0">
            <form onSubmit={this.handleSearchSubmit}>
              <div className="form-row mb-4">
                <div className="col-md-2">
                  <MInput {...this.state.searchField[0]} className="mb-0" />
                </div>

                <div className="col-md-2">
                  <MInput {...this.state.searchField[3]} className="mb-0" />
                </div>

                <div className="col-md-2">
                  <MSelect
                    {...this.state.searchField[1]}
                    payload={this.state.PAYLOAD_CLASS_COMPANY}
                  ></MSelect>
                </div>

                {/*<div className="col-md-2">
                  <MSelect
                    {...this.state.searchField[2]}
                    payload={this.state.PAYLOAD_CLASS_CATEGORYCODE}
                  ></MSelect>
                </div>*/}

                <div className="col-md-2 text-left">
                  <button type="submit" className="btn btn-primary bg-dark">
                    MOSTRA
                  </button>
                </div>

                <div className="col-md-2 text-right">
                  <button
                    type="button"
                    className="btn btn-btn btn-primary bg-success"
                    onClick={(e) => this.askGenerateQrCode()}
                  >
                    AGGIORNA QRCode
                  </button>
                </div>
              </div>
            </form>
          </section>

          <hr />

          <section className="my-4">
            {loading ? (
              <MnemoLoading></MnemoLoading>
            ) : (
              <Container>
                <MTable
                  key={this.state.rndKey}
                  tableData={this.state.payloadToRender}
                  tableConfig={this.tableConfig}
                />

                <div className="d-flex justify-content-center align-items-center mt-3 gap-3">
                  <button
                    type="button"
                    className="btn btn-primary bg-dark mr-2"
                    onClick={() => this.changePage(currentPage - 1)}
                    disabled={loading || currentPage <= 1}
                  >
                    Precedente
                  </button>

                  <div className="small text-muted">
                    Pagina {currentPage} di {totalPages} · Totale record:{" "}
                    {totalItems}
                  </div>

                  <button
                    type="button"
                    className="btn btn-primary bg-dark ml-2"
                    onClick={() => this.changePage(currentPage + 1)}
                    disabled={loading || currentPage >= totalPages}
                  >
                    Successiva
                  </button>
                </div>
              </Container>
            )}

            {this.state.hasSearched &&
              this.state.payloadToRender.length === 0 && (
                <BoxDanger key="nrp-1" className="my-3">
                  Ricerca non valida.
                  <div className="small text-info">
                    Nessun dato disponibile.
                  </div>
                </BoxDanger>
              )}
          </section>
        </div>
      </>
    );
  }
}

export default withRouter(LessonOnSiteClassBadge);
